// extracted by mini-css-extract-plugin
export default {"join-waitlist":"JoinWaitlist-module__join-waitlist--UHCF2"};